import * as React from 'react'

import { LeadAssignmentRuleFormProps } from './typings'

import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { LeadAssignmentRuleFormWrapper } from './LeadAssignmentRuleFormWrapper'

export function FullScreenDialogWrapper(props: LeadAssignmentRuleFormProps) {
  const { open, onClose, editValues, isEdit } = props

  const buttonText = `Close ${
    (isEdit ?? !!editValues) ? 'Edit' : 'Create New'
  } Assignment Rule`

  return (
    <FullScreenDialog
      open={open}
      onClose={onClose}
      closeButtonText={buttonText}
    >
      <LeadAssignmentRuleFormWrapper {...props} />
    </FullScreenDialog>
  )
}
